<template>
  <div class="container-main-body">
    <div style="position: relative; width: 30%; height: 100%; float: left; padding-top: 5px;">
      <div style="height: 30px;">
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="handlerAddCategory">新增物料分类</el-button>
        <el-button type="success" size="mini" icon="el-icon-refresh" @click="loadData">刷新</el-button>
      </div>
      <div style="position: absolute; top: 35px; right: 5px; bottom: 5px; left: 0;">
        <el-table size="mini" ref="categoryTable" :data="categories" style="width: 100%" height="100%" border header-row-class-name="list-header-row" row-class-name="list-row" highlight-current-row row-key="id" :tree-props="{children: 'children'}" @selection-change="handlerCategorySelectionChange" @current-change="handlerChangeCategory">
          <el-table-column type="selection" width="39" align="center"></el-table-column>
          <el-table-column prop="name" label="类别名称" width="90" align="center"></el-table-column>
          <el-table-column prop="code" label="类别编码" width="90" align="center"></el-table-column>
          <el-table-column prop="remark" label="备注" header-align="center"></el-table-column>
          <el-table-column label="操作" width="90" align="center">
            <template v-slot:default="scope">
              <el-button type="primary" size="mini" circle icon="el-icon-edit" @click="handlerEditCategory(scope.row)"></el-button>
              <el-button type="danger" size="mini" circle icon="el-icon-minus" @click="handlerDelCategory(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div style="position: relative; width: 70%; height: 100%; float: right; padding-top: 5px;">
      <div v-if="currentCategory.id !== '0'" style="height: 30px; font-size: 12px;">
        <span style="margin-left: 10px; font-weight: bold;">搜索</span>
        <span style="margin-left: 20px;">物料名称：</span>
        <el-input size="mini" v-model="query.materialName" placeholder="请输入物料名称" style="width: 120px; margin-right: 10px;"></el-input>
        <el-button type="primary" size="mini" icon="el-icon-search" @click="handlerSearchBaseMaterials">搜索</el-button>
        <div style="float: right; height: 28px; line-height: 28px;">
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="handlerAdd">新增物料</el-button>
          <el-button type="warning" size="mini" icon="el-icon-connection" @click="handlerMoveBaseMaterial">批量移动物料</el-button>
          <el-button type="success" size="mini" icon="el-icon-refresh" @click="loadMaterials">刷新</el-button>
        </div>
      </div>
      <div style="position: absolute; top: 35px; right: 0; bottom: 38px; left: 0;">
        <el-table size="mini" :data="materials" style="width: 100%" height="100%" header-row-class-name="list-header-row" row-class-name="list-row" border @selection-change="handlerMaterialSelectionChange">
          <el-table-column type="selection" width="39" align="center"></el-table-column>
          <el-table-column prop="name" label="物料名称" width="200" header-align="center">
            <template v-slot:default="scope">
              <el-input size="mini" v-if="scope.row.edit_status==='是'" placeholder="物料名称" v-model="scope.row.name"></el-input>
              <span v-else>{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" header-align="center">
            <template v-slot:default="scope">
              <el-input size="mini" v-if="scope.row.edit_status==='是'" placeholder="备注" v-model="scope.row.remark"></el-input>
              <span v-else>{{scope.row.remark}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="90" align="center">
            <template v-slot:default="scope">
              <template v-if="scope.row.edit_status==='否'">
                <el-button type="primary" size="mini" circle icon="el-icon-edit" @click="scope.row.edit_status='是'"></el-button>
                <el-button type="danger" size="mini" circle icon="el-icon-minus" @click="handlerDel(scope.row)"></el-button>
              </template>
              <template v-else>
                <el-button type="success" size="mini" circle icon="el-icon-finished" @click="handlerSave(scope.row)"></el-button>
                <el-button type="danger" size="mini" circle icon="el-icon-close" @click="scope.row.edit_status='否'"></el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <ezz-category-dialog-form ref="CForm" :parent="this" />
    <ezz-move-material-dialog-form ref="MMForm" :parent="this" />
  </div>
</template>
<script>
import EzzCategoryDialogForm from '@/views/modules/base/baseMaterial/CategoryForm.vue'
import EzzMoveMaterialDialogForm from '@/views/modules/base/baseMaterial/MoveMaterialForm.vue'
export default {
  data: function () {
    return {
      queryCategory: {
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      query: {
        categoryId: '',
        materialName: '',
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      emptyMaterialData: {
        id: '0',
        category_id: '',
        name: '',
        remark: '',
        edit_status: '是'
      },
      categories: [],
      materials: [],
      selectedCategoryIds: [],
      selectedIds: [],
      currentCategory: {
        id: '0'
      },
      operator_id: sessionStorage.getItem('operator_id')
    }
  },
  created: function () {
  },
  mounted: function () {
    this.loadData()
  },
  methods: {
    // 加载数据
    loadData: function () {
      const _this = this
      _this.post(_this.$apis.getBaseMaterialCategories, _this.queryCategory, function (res) {
        const _json = res.data
        if (_json.status && _json.status === 'logout') {
          window.location.hash = '/'
        } else {
          _this.categories = _json.dataList
          if (_this.categories.length > 0) {
            _this.$refs.categoryTable.setCurrentRow(_this.categories[0])
          } else {
            _this.currentCategory.materials = []
          }
        }
      })
    },
    loadMaterials: function () {
      const _this = this
      _this.query.categoryId = _this.currentCategory.id
      _this.post(_this.$apis.getBaseMaterials, _this.query, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          window.location.hash = '/'
        } else {
          _this.materials = _json.dataList
        }
      })
    },
    // 新增物料类别
    handlerAddCategory: function () {
      this.$refs.CForm.handlerAdd()
    },
    handlerEditCategory: function (_row) {
      this.$refs.CForm.handlerEdit(_row.id)
    },
    // 删除物料类别
    handlerDelCategory: function (_row) {
      const _this = this
      _this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _params = {
          ids: _row.id,
          operator_id: _this.operator_id
        }
        // ajax提交至服务器，删除数据
        _this.post(_this.$apis.delBaseMaterialCategories, _params, function (res) {
          let _json = res.data
          if (_json.status === 'ok') {
            _this.loadData()
            _this.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
            _this.$message({
              type: 'error',
              message: '无数据更新!'
            })
          }
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 物料类别 行选择事件
    handlerChangeCategory: function (_newRow, _oldRow) {
      this.currentCategory = _newRow
      this.loadMaterials()
    },
    // 物料类别 checkbox选择事件
    handlerCategorySelectionChange: function (selection) {
      this.selectedCategoryIds = []
      for (let _i = 0; _i < selection.length; ++_i) {
        this.selectedCategoryIds.push(selection[_i].id)
      }
    },
    handlerSearchBaseMaterials: function () {
      this.loadMaterials()
    },
    /**********************************************/
    // 新增物料
    handlerAdd: function () {
      const newMaterial = JSON.parse(JSON.stringify(this.emptyMaterialData))
      newMaterial.category_id = this.currentCategory.id
      this.materials.push(newMaterial)
    },
    handlerDel: function (_row) {
      const _this = this

      _this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _params = {
          ids: _row.id,
          categoryId: _this.currentCategory.id,
          operator_id: _this.operator_id
        }
        // ajax提交至服务器，删除数据
        _this.post(_this.$apis.delBaseMaterials, _params, function (res) {
          let _json = res.data
          if (_json.status === 'ok') {
            _this.materials = _json.materials
            _this.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
            _this.$message({
              type: 'error',
              message: '无数据更新!'
            })
          }
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handlerSave: function (_row) {
      const _this = this
      if (_row.name === '') {
        _this.$message({
          type: 'error',
          message: '物料名称不能为空!'
        })
      } else {
        _row.operator_id = sessionStorage.getItem('operator_id')
        // ajax提交至服务器，保存数据
        _this.post(_this.$apis.saveBaseMaterial, _row, function (res) {
          let _json = res.data
          if (_json.status === 'ok') {
            _this.$message({
              type: 'success',
              message: '操作成功!'
            })
            _row.edit_status = '否'
          } else {
            _this.$message({
              type: 'error',
              message: '无数据更新!'
            })
          }
        })
      }
    },
    // 多选物料事件
    handlerMaterialSelectionChange: function (selection) {
      this.selectedIds = []
      for (let _i = 0; _i < selection.length; ++_i) {
        this.selectedIds.push(selection[_i].id)
      }
    },
    pageChange: function (pn) {
      this.query.pn = pn
      this.loadMaterials()
    },
    pageSizeChange: function (pageSize) {
      this.query.pn = 1
      this.query.pageSize = pageSize
      this.loadMaterials()
    },
    // 刷新事件
    refreshHandler: function () {
      this.loadMaterials()
    },
    // 批量修改物料类别
    handlerMoveBaseMaterial: function () {
      if (this.selectedIds.length === 0) {
        this.$message({
          type: 'error',
          message: '至少选择一条物料!'
        })
      } else {
        this.$refs.MMForm.handlerOpen()
      }
    }
  },
  components: {
    EzzCategoryDialogForm,
    EzzMoveMaterialDialogForm
  }
}
</script>
